import {DataService} from '../Services/data.service';
import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {
  isMonday,
  isTuesday,
  isWednesday,
  isThursday,
  isFriday,
  isSaturday,
  isSunday,
  isToday,
  isFuture,
} from 'date-fns';
import {PersonLunch} from '../Model/PersonLunch';
// @ts-ignore
import {Moment} from 'moment/moment';

@Component({
  selector: 'app-statistics-kantine',
  templateUrl: './statisticsCanteen.component.html',
  styleUrls: ['./statisticsCanteen.component.css'],
})

export class StatisticsCanteenComponent implements OnInit {

  weekdays = [
    {name: 'Monday', lunches: [], definitive: 0, submit: 0, employees: 0, guests: 0, notSubscribedDidLunch: [], subscribedNotLunched: []},
    {name: 'Tuesday', lunches: [], definitive: 0, submit: 0, employees: 0, guests: 0, notSubscribedDidLunch: [], subscribedNotLunched: []},
    {name: 'Wednesday', lunches: [], definitive: 0, submit: 0, employees: 0, guests: 0, notSubscribedDidLunch: [], subscribedNotLunched: []},
    {name: 'Thursday', lunches: [], definitive: 0, submit: 0, employees: 0, guests: 0, notSubscribedDidLunch: [], subscribedNotLunched: []},
    {name: 'Friday', lunches: [], definitive: 0, submit: 0, employees: 0, guests: 0, notSubscribedDidLunch: [], subscribedNotLunched: []},
  ];

  weekdaysDate = [];
  isTodayStyles = ['', '', '', '', ''];
  today;
  dateToWatch;

  constructor(private dataService: DataService, private router: Router) {

  }

  /**
   * check the role of the logged in {@link Person}
   * If Role is not 7 (Kantine/canteen) user will be redirected to login page
   */
  checkRole(): void {
    if (this.dataService.role.id !== 7) {
      this.router.navigateByUrl('aanmelden');
    }
  }

  /**
   * ngOnInit has the following functions:
   * Check the role of the {@link Person} with {@link checkRole}
   * the date of {@link today} and {@link dateToWatch} will be set to today's date
   * After that today's date will be bold using the {@link checkIfTodayIsVisible} function
   * get the statistics of this week
   * get the dates visible in this week
   */
  ngOnInit(): void {
    this.checkRole();
    this.today = new Date();
    this.dateToWatch = new Date();
    this.checkIfTodayIsVisible();
    this.getStatisticsOfThisWeek();
    this.getDatesOfThisWeek(0);
  }

  /**
   * Check if todays date is visible,
   * If the date is visible make it bold so the Canteen will see quickly which day it is and how much persons are expected
   */
  checkIfTodayIsVisible(): void {
    this.weekdays.forEach((day, index) => {
      if (isToday(this.dateToWatch) && day.name === this.dateToWatch.toLocaleDateString('en-GB', {weekday: 'long'})) {
        this.isTodayStyles[index] = 'bold';
      }
    });
  }

  /**
   * Get the dates of the current week, after retrieving these dates check if today's date is visible
   */
  getDatesOfThisWeek(diff: number): void {
    // Adjusted for better readability
    const day = new Date(this.dateToWatch);
    day.setDate(day.getDate() + diff);
    this.dateToWatch = this.getWeeksMondayDate(this.dateToWatch);
    this.checkIfTodayIsVisible();

    this.weekdaysDate = this.weekdays.map((day) => {
      const moment = require('moment');
      const dateToSet = moment(this.dateToWatch);
      const date = dateToSet.format('DD/MM');
      if (dateToSet.toDate().toLocaleDateString('en-GB', {weekday: 'long'}) !== 'Friday') {
        dateToSet.add(1, 'd');
      }
      this.dateToWatch = dateToSet.toDate();
      this.checkIfTodayIsVisible();
      return date;
    });
  }

  getWeeksMondayDate(reqDate): Date {
    const moment = require('moment');
    let d = new Date(reqDate);
    const day = d.getDay();
    const dateToCalculate = moment(d).add(-day, 'd');
    if (day === 0) {
      dateToCalculate.add(-6, 'd');
    } else {
      dateToCalculate.add(1, 'd');
    }
    d = dateToCalculate.toDate();
    return d;
  }

  /**
   * Get the statistics of this week
   * Use the response to call {@link processStatistics}
   */
  getStatisticsOfThisWeek(): void {
    this.dataService.getStatisticsOfThisWeek().then((response) => {
      this.processStatistics(response);
    })
  }

  /**
   * When changing the week all variables needs to be reset.
   * After everything is reset, the dates of this week will be shown
   */
  resetGlobalVariables(): void {
    this.weekdays.forEach((day) => {
      day.lunches = [];
      day.definitive = 0;
      day.submit = 0;
      day.employees = 0;
      day.guests = 0;
      day.notSubscribedDidLunch = [];
      day.subscribedNotLunched = [];
    });

    this.isTodayStyles = ['', '', '', '', ''];
    this.getDatesOfThisWeek(0);
  }

  /**
   * Process the retrieved statistics
   * The function will count all {@link PersonLunch} with lunch: true and didLunch: true and shown these statistics
   * @param {PersonLunch[]} lunches retrieved from the server
   */
  processStatistics(lunches: PersonLunch[]): void {
    lunches.forEach((lunch) => {
      const dayIndex = this.weekdays.findIndex((day) => this.checkDay(lunch.date, day.name));

      if (dayIndex !== -1) {
        const day = this.weekdays[dayIndex];
        day.lunches.push(lunch);

        if (lunch.lunch) {
          day.employees++;
          if (lunch.guestAmount) {
            day.guests += lunch.guestAmount;
          }
          day.submit = day.employees + day.guests;
          if (!lunch.didLunch && !isFuture(lunch.date)) {
            day.subscribedNotLunched.push(lunch);
          }
        }

        if (lunch.didLunch) {
          day.definitive += 1 + lunch.guestAmount;
          if (!lunch.lunch) {
            day.notSubscribedDidLunch.push(lunch);
          }
        }
      }
    });
  }

  /**
   * get the statistics of the previous week
   */
  previousWeek(): void {
    const moment = require('moment');
    const dateToSet = moment(this.dateToWatch);
    dateToSet.add(-7, 'd');
    this.dateToWatch = dateToSet.toDate();
    this.dataService.getStatisticsOfWeekWithDate(this.dateToWatch).then((response) => {
      this.resetGlobalVariables();
      this.processStatistics(response);
      this.checkIfTodayIsVisible();
    });
  }

  /**
   * get the statistics of the next week
   */
  nextWeek(): void {
    const moment = require('moment');
    const dateToSet = moment(this.dateToWatch);
    dateToSet.add(7, 'd');
    this.dateToWatch = dateToSet.toDate();
    this.dataService.getStatisticsOfWeekWithDate(this.dateToWatch).then((response) => {
      this.resetGlobalVariables();
      this.processStatistics(response);
      this.checkIfTodayIsVisible();
    });
  }

  private handleStatisticsOfWeekWithDate() {
    this.dataService.getStatisticsOfWeekWithDate(this.dateToWatch).then((response) => {
      this.resetGlobalVariables();
      this.processStatistics(response);
    });
  }

  private checkDay(date: Date, dayName: string): boolean {
    switch (dayName.toLowerCase()) {
      case 'monday':
        return isMonday(date);
      case 'tuesday':
        return isTuesday(date);
      case 'wednesday':
        return isWednesday(date);
      case 'thursday':
        return isThursday(date);
      case 'friday':
        return isFriday(date);
      default:
        return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/StatisticsCanteen/statisticsCanteen.component.ts